// extracted by mini-css-extract-plugin
export default {"SubCategorySection":"MultiStepper_SubCategorySection__p2d8E","componentsSection":"MultiStepper_componentsSection__5u7jW"};